<div [ngClass]="{ 'hidden-panel': hiddenPanel }">
    @if (addBlockType == 'BLOCK_RESOURCES') {
        <mat-tab-group [@.disabled]="true" tabGroupDrag class="mini-tab" mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="selectTab($event)">
             @for (item of m_resourceModes; track item) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="menu-button">
                                @switch (item) {
                                    @case ('resources') {
                                        <mat-icon>workspaces_outline</mat-icon>
                                        files
                                    }
                                    @case ('library') {
                                        <mat-icon>star_rate</mat-icon>
                                        {{ "general." + item | transloco }}
                                    }
                                    @case ('upload') {
                                        <mat-icon>upload_file</mat-icon>
                                        {{ "general." + item | transloco }}
                                    }
                                }
                        </div>
                    </ng-template>
                </mat-tab>
             }
        </mat-tab-group>
    }
    @if (addBlockType == 'BLOCK_SCENES') {
        <mat-tab-group [@.disabled]="true" tabGroupDrag class="mini-tab" mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="selectTab($event)">

            @for (item of m_sceneModes; track item) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="menu-button">
                            @if (item === 'scenes') {
                                <mat-icon>dashboard_customize</mat-icon>
                            } @if (item === 'library') {
                                <mat-icon>star_rate</mat-icon>
                            }
                            {{ "general." + item | transloco }}
                        </div>
                    </ng-template>
                </mat-tab>
            }

        </mat-tab-group>
    }

    @if (contentMode == 'scenes' || contentMode == 'resources') {
        <div>
            <div fxLayout="row" fxLayoutAlign="space-between center" style="padding: 0 5px">
                <mat-form-field class="filter">
                    <mat-label>{{ "placeholder.filterList" | transloco }}</mat-label>
                    <input
                        inputrestriction="basic1"
                        matInput
                        autocomplete="off"
                        type="text"
                        (keyup)="applyFilter($event.target['value'])"
                        name="SearchDualList"
                        class="form-control"
                        [(ngModel)]="filter"
                        autocomplete="off"
                    />
                    <a matSuffix aria-label="clear" (click)="clearSelection()">
                        <mat-icon>close</mat-icon>
                    </a>
                </mat-form-field>
                <button class="star mini-button" mat-icon-button (click)="openAssociateDialog()">
                    <mat-icon>aspect_ratio</mat-icon>
                </button>
                @if (contentMode == 'resources') {
                    <button class="mini-button" mat-icon-button (click)="isGridView = !isGridView">
                        @if (isGridView) {
                            <mat-icon>view_quilt</mat-icon>
                        } @else {
                            <mat-icon>view_stream</mat-icon>
                        }
                    </button>
                }
                <div class="hide-gt-sm">
                    <app-scroll-buttons contentId="tableList"></app-scroll-buttons>
                </div>
                @if (contentMode == 'resources') {
                    <app-video-link videoLink="resourceFilesToolbox"></app-video-link>
                }
                @if (contentMode == 'scenes') {
                    <app-video-link videoLink="scenesToolbox"></app-video-link>
                }
            </div>
            <div class="content-table-wrapper" id="tableList">
                @if (isGridView) {
                    <div fxLayout="row wrap" fxLayoutAlign="center" style="margin-top: 10px; margin-bottom: 10px;" cdkDropList cdkDropListSortingDisabled (cdkDropListDropped)="dropBlock($event)">
                        @for (item of dataSourceThumbnails$ | async; track item) {
                            <div cdkDrag [cdkDragData]="item" class="dragCursor thumbs fixed-width"
                                [ngClass]="{'selected': selection.isSelected($any(item.resource.resource_id))}"
                                (click)="onSelectedThumb(item.resource)"
                                (cdkDragMoved)="onDraggingItem($event)">
                                <mat-icon (click)="addBlock(item)" class="thumbsHide fade-in-image">control_point</mat-icon>
                                @if (item.resource.resource_type !== 'mp4') {
                                    <img class="thumb-img" [src]="(item.resource | PipeResourceUrl:item.resource:coreAppData).url" loading="lazy"
                                         onerror="this.src='./assets/images/no_image.png'">
                                }
                                @if (item.resource.resource_type === 'mp4') {
                                    <div class="thumb-video">
                                        <vg-player>
                                            <vg-controls>
                                                <vg-play-pause></vg-play-pause>
                                                <vg-playback-button></vg-playback-button>
                                                <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
                                                <vg-scrub-bar>
                                                    <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                                                    <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                                                </vg-scrub-bar>
                                                <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                                                <vg-mute></vg-mute>
                                                <vg-volume></vg-volume>
                                                <vg-fullscreen></vg-fullscreen>
                                            </vg-controls>
                                            <video id="singleVideo" [vgMedia]="$any(media)" #media [autoplay]="false" preload="auto">
                                                <source [src]="(item.resource | PipeResourceUrl:item.resource:coreAppData).videoUrl" type="video/mp4">
                                            </video>
                                        </vg-player>
                                    </div>
                                }
                                <div style="font-size: 11px;">
                                    {{ item.resource.resource_name | PipeTruncate:['10'] }}.{{ item.resource.resource_type }}
                                </div>
                            </div>
                        }
                    </div>
                } @else {
                    <table mat-table matSort [dataSource]="dataSource" cdkDropList cdkDropListSortingDisabled (cdkDropListDropped)="dropBlock($event)">
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ "general.import" | transloco }}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <a class="pull-left mini-button" mat-icon-button (click)="addBlock(row)">
                                    <mat-icon>add_circle_outline</mat-icon>
                                </a>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="name">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "general.name" | transloco }}</th>
                            <td mat-cell style="padding-left: 3px" *matCellDef="let element">{{ element.name | PipeTruncate : ["15"] }}</td>
                        </ng-container>
                        <ng-container matColumnDef="type">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "general.type" | transloco }}</th>
                            <td mat-cell *matCellDef="let element">{{ element.mimeType ? element.mimeType : element.type }}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag [cdkDragData]="row" class="dragCursor" (cdkDragMoved)="onDraggingItem($event)">
                            <div
                                *cdkDragPreview
                                class="drag-preview"
                                [ngStyle]="{
                                    'width.px': dragItemSize,
                                    'height.px': dragItemSize
                                }"
                            >
                                {{ row.mimeType }}
                            </div>
                        </tr>
                    </table>
                }
            </div>
            <ng-container>
                <mat-paginator
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    [showFirstLastButtons]="true"
                    class="mini-paginator"
                    (page)="onChangePagination($event)">
                </mat-paginator>
            </ng-container>
        </div>
    }
    @else if (contentMode == 'library') {
        <div>
            @if (addBlockType == 'BLOCK_SCENES') {
                <div>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="flex-lt-md-col">
                        <mat-form-field class="filter drop-down">
                            <mat-label>{{ "general.categorizedScenes" | transloco }}</mat-label>
                            <mat-select [formControl]="categoryControl" multiple (selectionChange)="updateSceneCategories()" class="resource-cats" panelClass="library-categories-dropdown mat-warn">
                                <!-- <mat-optgroup *ngFor="let group of categorySceneOptions" [label]="group.folder">
                        <mat-option *ngFor="let item of group.items" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                        </mat-optgroup> -->
                                @for (item of categorySceneOptions; track item) {
                                <mat-option [value]="item.id">
                                    {{ item.name }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <div fxLayout="row" class="hide-lt-md">
                            <a mat-icon-button (click)="openAssociateDialog()" class="mini-button">
                                <mat-icon matTooltip="{{ 'general.importScene' | transloco }}">star</mat-icon>
                            </a>
                            <a mat-icon-button (click)="toggleBlockSize()" class="mini-button">
                                <span style="opacity: 0.8" matTooltip="{{ 'general.toggleSmallView' | transloco }}">
                                    @if (!blockSmallView) {
                                    <svg viewBox="0 0 448 512" class="svg-inline--fa fa-grid-2 fa-lg">
                                        <path
                                            fill="currentColor"
                                            d="M192 80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336zM256 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zM448 336c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z"
                                            class=""
                                        ></path>
                                    </svg>
                                    }
                                </span>
                                @if (blockSmallView) {
                                <mat-icon matTooltip="{{ 'general.toggleLargeView' | transloco }}">apps</mat-icon>
                                }
                            </a>

                            <app-video-link videoLink="sceneLibToolbox"></app-video-link>

                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="hide-gt-sm">
                            <a mat-icon-button (click)="openAssociateDialog()" class="mini-button">
                                <mat-icon matTooltip="{{ 'general.importScene' | transloco }}">star</mat-icon>
                            </a>
                            <a mat-icon-button (click)="toggleBlockSize()" class="mini-button">
                                <span style="opacity: 0.8" matTooltip="{{ 'general.toggleSmallView' | transloco }}">
                                    @if (!blockSmallView) {
                                    <svg viewBox="0 0 448 512" class="svg-inline--fa fa-grid-2 fa-lg">
                                        <path
                                            fill="currentColor"
                                            d="M192 80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336zM256 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zM448 336c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z"
                                            class=""
                                        ></path>
                                    </svg>
                                    }
                                </span>
                                @if (blockSmallView) {
                                <mat-icon matTooltip="{{ 'general.toggleLargeView' | transloco }}">apps</mat-icon>
                                }
                            </a>
                            <app-scroll-buttons contentId="sceneList"></app-scroll-buttons>
                        </div>
                    </div>
                    <div
                        class="content-wrapper"
                        id="sceneList"
                        infinite-scroll
                        [scrollWindow]="false"
                        [infiniteScrollDistance]="scrollDistance"
                        [infiniteScrollThrottle]="throttle"
                        (scrolled)="loadMoreSceneTemplates()"
                    >
                        @if (m_sceneTemplates && m_sceneTemplates.length > 0) {
                        <div
                            cdkDropList
                            cdkDropListSortingDisabled
                            fxLayout="row wrap"
                            fxLayoutAlign="center center"
                            class="drag-panel dragCursor import-nav-bg"
                            [ngClass]="{ 'small-view': blockSmallView }"
                            [cdkDropListData]="currentSceneTemplates"
                            (cdkDropListDropped)="dropLibraryItem($event)"
                        >
                            @for (scene of currentSceneTemplates; track scene) {
                            <div cdkDrag class="thumbs" [cdkDragData]="scene" (cdkDragMoved)="onDraggingItem($event)">
                                <mat-icon (click)="showImportDialog(scene)" class="thumbsHide fade-in-image">control_point</mat-icon>
                                <img class="shadow-grow" loading="lazy" [src]="scene.url" />
                                <div
                                    *cdkDragPreview
                                    class="drag-preview"
                                    [ngStyle]="{
                                        'width.px': dragItemSize,
                                        'height.px': dragItemSize
                                    }"
                                >
                                    <img [src]="scene.url" />
                                </div>
                            </div>
                            }
                        </div>
                        } @else {
                        <div class="import-nav-bg">
                            <div class="imageWrap" style="width: 100%; height: 100%" fxLayout="row" fxLayoutAlign="center center">
                                <h1>{{ "general.sceneCollection" | transloco }}</h1>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            }
            @if (addBlockType == 'BLOCK_RESOURCES') {
                <div>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="flex-lt-md-col">
                        <mat-form-field class="filter drop-down" style="margin-left: 5px">
                            <mat-label>{{ "general.categories" | transloco }}</mat-label>
                            <mat-select [formControl]="categoryControl" panelClass="library-categories-dropdown mat-warn" (selectionChange)="updateResourceCategories()" multiple>
                                @for (item of categoryResOptions; track item) {
                                    <mat-option [value]="item.id">
                                        {{ item.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <div fxLayout="row" class="hide-lt-md">
                            <a mat-icon-button (click)="openAssociateDialog()" class="mini-button">
                                <mat-icon matTooltip="{{ 'general.importResourceFromLibrary' | transloco }}">star</mat-icon>
                            </a>
                            <a mat-icon-button (click)="toggleBlockSize()" class="mini-button">
                                <span style="opacity: 0.8" matTooltip="{{ 'general.toggleSmallView' | transloco }}">
                                    @if (!blockSmallView) {
                                        <svg viewBox="0 0 448 512" class="svg-inline--fa fa-grid-2 fa-lg">
                                            <path
                                                fill="currentColor"
                                                d="M192 80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336zM256 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zM448 336c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z"
                                                class=""
                                            ></path>
                                        </svg>
                                    }
                                </span>
                                @if (blockSmallView) {
                                    <mat-icon matTooltip="{{ 'general.toggleLargeView' | transloco }}">apps</mat-icon>
                                }
                            </a>
                            <app-video-link videoLink="resourceLibToolbox"></app-video-link>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="hide-gt-sm">
                            <a mat-icon-button (click)="openAssociateDialog()" class="mini-button">
                                <mat-icon matTooltip="{{ 'general.importResourceFromLibrary' | transloco }}">star</mat-icon>
                            </a>
                            <a mat-icon-button (click)="toggleBlockSize()" class="mini-button">
                                <span style="opacity: 0.8" matTooltip="{{ 'general.toggleSmallView' | transloco }}">
                                    @if (!blockSmallView) {
                                        <svg viewBox="0 0 448 512" class="svg-inline--fa fa-grid-2 fa-lg">
                                            <path
                                                fill="currentColor"
                                                d="M192 80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336zM256 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zM448 336c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z"
                                                class=""
                                            ></path>
                                        </svg>
                                    }
                                </span>
                                @if (blockSmallView) {
                                    <mat-icon matTooltip="{{ 'general.toggleLargeView' | transloco }}">apps</mat-icon>
                                }
                            </a>
                            <app-scroll-buttons contentId="resourceList"></app-scroll-buttons>
                        </div>
                    </div>
                    <div
                        class="content-wrapper"
                        id="resourceList"
                        infinite-scroll
                        [scrollWindow]="false"
                        [infiniteScrollDistance]="scrollDistance"
                        [infiniteScrollThrottle]="throttle"
                        (scrolled)="loadMoreResources()"
                    >
                        @if (m_sharedResources && m_sharedResources.length > 0) {
                            <div
                                cdkDropList
                                cdkDropListSortingDisabled
                                fxLayout="row wrap"
                                fxLayoutAlign="center center"
                                class="drag-panel dragCursor import-nav-bg"
                                [ngClass]="{ 'small-view': blockSmallView }"
                                [cdkDropListData]="currentResources"
                                (cdkDropListDropped)="dropLibraryItem($event)"
                            >
                                @for (res of currentResources; track res) {
                                    <div cdkDrag class="thumbs" [cdkDragData]="res" (cdkDragMoved)="onDraggingItem($event)">
                                        <!-- <mat-icon (click)="showImportDialog(res)" class="thumbsHide fade-in-image">control_point</mat-icon> -->
                                        <div>
                                            @switch (res.type) {
                                                @case ('image') {
                                                    <div>
                                                        <img class="shadow-grow" loading="lazy" [src]="res.url" />
                                                    </div>
                                                } @case ('video') {
                                                    <div class="shadow-grow">
                                                        @if (ready) {
                                                            <vg-player>
                                                                <vg-controls>
                                                                    <vg-play-pause></vg-play-pause>
                                                                    <vg-playback-button></vg-playback-button>
                                                                    <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
                                                                    <vg-scrub-bar>
                                                                        <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                                                                        <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                                                                    </vg-scrub-bar>
                                                                    <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                                                                    <vg-mute></vg-mute>
                                                                    <vg-volume></vg-volume>
                                                                    <vg-fullscreen></vg-fullscreen>
                                                                </vg-controls>
                                                                <video id="singleVideo" [vgMedia]="$any(media)" #media [autoplay]="false" preload="auto">
                                                                    <source src="{{ res.videoUrl }}" type="video/mp4" />
                                                                </video>
                                                            </vg-player>
                                                        }
                                                    </div>
                                                }
                                                @case ('flash') {
                                                    <div>
                                                        <img class="shadow-grow" loading="lazy" [src]="res.videoUrl" />
                                                    </div>
                                                }
                                                @case ('svg') {
                                                    <div>
                                                        <img class="shadow-grow" loading="lazy" [src]="res.url" />
                                                    </div>
                                                }
                                            }
                                        </div>
                                        <div
                                            *cdkDragPreview
                                            class="drag-preview"
                                            [ngStyle]="{'width.px': dragItemSize, 'height.px': dragItemSize}"
                                        >
                                            <img [src]="res.url" />
                                        </div>
                                    </div>
                                }
                            </div>
                        } @else {
                            <div class="import-nav-bg">
                                <div class="imageWrap" style="width: 100%; height: 100%">
                                    <!--                            <h1>{{'general.resourcesCollection' | transloco}}</h1>-->
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    } @if (contentMode == 'upload') {
        <div>
            <app-resource-upload></app-resource-upload>
        </div>
    }
</div>

<ng-template let-modal #downloadModal class="transparentDialog">
    <div mat-dialog-content>
        <br />
        <br />
        <br />
        <div fxLayout="column" fxLayoutAlign="center center">
            <div>
                <app-loading [type]="9" [size]="'40px'"></app-loading>
            </div>
            <div style="margin: 15px" fxFlex fxLayoutAlign="center center">
                <mat-icon style="margin-right: 10px">file_download</mat-icon>
                <span>{{ resourceName }}</span>
            </div>
            <button mat-mini-fab color="primary" (click)="onClose()" class="fade-in" style="margin-top: 10px">
                <mat-icon style="transform: scale(1.2)">close</mat-icon>
            </button>
        </div>
        <br />
        <br />
    </div>
</ng-template>

<ng-template let-modal #importPopup>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        {{ "general.import" | transloco }}
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div mat-dialog-content>
        @if (selectedItem.type === 'scene') {
            <div fxLayout="row wrap" fxLayoutAlign="center center" class="align-stretch">
                <mat-form-field class="info1">
                    <mat-label>{{ "general.name" | transloco }}</mat-label>
                    <input matInput type="text" placeholder="" value="{{ selectedItem.title | PipeTruncate : ['35'] }}" readonly />
                </mat-form-field>
                <mat-form-field class="info2">
                    <mat-label>{{ "general.width" | transloco }}</mat-label>
                    <input matInput type="text" placeholder="" value="{{ selectedItem.width }}" readonly />
                </mat-form-field>
                <mat-form-field class="info2">
                    <mat-label>{{ "general.height" | transloco }}</mat-label>
                    <input matInput type="text" placeholder="" value="{{ selectedItem.height }}" readonly />
                </mat-form-field>
            </div>
        } @else {
            <div fxLayout="row wrap" fxLayoutAlign="center center" class="align-stretch">
                <mat-form-field class="info1">
                    <mat-label>{{ "general.name" | transloco }}</mat-label>
                    <input matInput type="text" placeholder="" value="{{ selectedItem.title | PipeTruncate : ['35'] }}" readonly />
                </mat-form-field>
                <mat-form-field class="info1">
                    <mat-label>{{ "general.category" | transloco }}</mat-label>
                    <input matInput type="text" placeholder="" value="{{ selectedItem.category }}" readonly />
                </mat-form-field>
                <mat-form-field class="info2">
                    <mat-label>{{ "general.type" | transloco }}</mat-label>
                    <input matInput type="text" placeholder="" value="{{ selectedItem.type }}" readonly />
                </mat-form-field>
            </div>
        }
        @if (selectedItem.type === 'mp4') {
            <div>
                <vg-player>
                    <vg-controls>
                        <vg-play-pause></vg-play-pause>
                        <vg-playback-button></vg-playback-button>
                        <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
                        <vg-scrub-bar>
                            <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                            <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                        </vg-scrub-bar>
                        <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                        <vg-mute></vg-mute>
                        <vg-volume></vg-volume>
                        <vg-fullscreen></vg-fullscreen>
                    </vg-controls>
                    <video [vgMedia]="$any(media)" #media [autoplay]="false" preload="auto">
                        <source src="{{ selectedItem.videoUrl }}" type="video/mp4" />
                    </video>
                </vg-player>
            </div>
        }
        @if (selectedItem.type !== 'mp4') {
            <div class="image-wrapper">
                @if (imageLoading) {
                    <div style="height: 300px; padding-top: 110px">
                        <app-loading [type]="-1" [size]="'60px'"></app-loading>
                    </div>
                }
                <div [hidden]="imageLoading">
                    <img class="image-preview" (load)="onLoad($event)" src="{{ selectedItem.url }}" />
                </div>
                @if (imageImporting) {
                    <div class="import-image">
                        <app-loading [type]="9" [size]="'60px'"></app-loading>
                    </div>
                }
            </div>
        }
        <br />
        <br />
        <div fxFlex fxLayoutAlign="center center" fxLayoutGap="32px">
            <button mat-raised-button color="warn" (click)="importLibrary()">
                <mat-icon>downloading</mat-icon>
                {{ "general.import" | transloco }}
            </button>
            <button mat-raised-button color="primary" (click)="onClose()">{{ "general.cancel" | transloco }}</button>
        </div>
    </div>
</ng-template>
